import type { EquipmentStatusFilter } from '@/features/equipment/-query/type';
import type { EquipmentListInput } from '@/features/equipment/query/list/type';
export function shouldShowPlaceFiltersForViewMode(viewMode: EquipmentListInput['viewMode']): boolean {
  return viewMode !== 'person';
}
export function shouldShowPlacementPlaceFilter(status: EquipmentStatusFilter): boolean {
  return status === 'ALL' || status === 'PLACED';
}
export function shouldShowWarehousingPlaceFilter(status: EquipmentStatusFilter): boolean {
  return status === 'ALL';
}
export function shouldShowEquipmentListFilterDef(filterId: string, status: EquipmentStatusFilter): boolean {
  switch (filterId) {
    case 'placementPlaceIdIn':
      return shouldShowPlacementPlaceFilter(status);
    case 'warehousingPlaceIdIn':
      return shouldShowWarehousingPlaceFilter(status);
    default:
      return true;
  }
}
type PlaceFilterSearchPatch = {
  placementPlaceIdIn?: undefined;
  warehousingPlaceIdIn?: undefined;
};
export function buildPlaceFilterClearOnTabChange(status: EquipmentStatusFilter): PlaceFilterSearchPatch {
  const patch: PlaceFilterSearchPatch = {};
  if (!shouldShowPlacementPlaceFilter(status)) {
    patch.placementPlaceIdIn = undefined;
  }
  if (!shouldShowWarehousingPlaceFilter(status)) {
    patch.warehousingPlaceIdIn = undefined;
  }
  return patch;
}